import advanteTeam from "../../images/advante-team.webp"

const OurTeam = () => {
  return (
    <>
      <section className="about-team">

        <div className="bgr-noise"></div>

        <div className="bgr-white-bottom"></div>

        <div className="about-team-content containerFull">
          <div className="team-headline">
            <h1>A <span>senior-led</span> delivery team.</h1>
            <div className='about-wave team-divider-wave'>
              <svg viewBox="0 0 1920 140">
                  <path/>
              </svg>
            </div>
            <p className="team-headline-copy">Advante combines product thinking, project management, software engineering, QA, and AI-assisted development. Motionode helps us keep the work organized: every request becomes a ticket, every ticket is connected to code changes, and every change moves through review, staging, QA, and controlled deployment.</p>
          </div>
          <div className="team-image">
            <img 
              src={advanteTeam} 
              alt="Advante Team" 
            />
          </div>
        </div>

      </section>

    </>
  );
};

export default OurTeam;
